import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { ButtonVariant } from '../../../../components/Button/Button';
import Icon, { IconType } from '../../../../icons/Icon';
import { OnboardingStep, OnboardingTitle } from '../../components';
import OnboardingPaneHeader from '../../components/OnboardingPaneHeader';
import { OnboardingData, OnboardingRoutes } from '../..';
import OnboardingStockLocationItem from './components/OnboardingStockLocationItem';

interface OnboardingStockOverviewPaneProps {
  data: OnboardingData;
  setData: (data: OnboardingData) => void;
}

export default function OnboardingStockLocationOverviewPane({ data, setData }: OnboardingStockOverviewPaneProps) {
  const navigate = useNavigate();

  return (
    <div className='grid gap-4 overflow-auto'>
      <OnboardingPaneHeader back={() => navigate(OnboardingRoutes.stockLocationImport)} />
      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Overview of your Stock Locations'} />
      </div>

      <div className='grid gap-2 overflow-auto'>
        <p className='text-sm font-medium text-black'>Stock Locations added</p>
        <div className='grid gap-2 overflow-auto'>
          {[...data.summary.stockLocations.values()].map(sl => (
            <OnboardingStockLocationItem stockLocation={sl} key={sl.name} data={data} setData={setData} />
          ))}
        </div>
        <Button
          className='w-fit'
          text={'Add new stock location'}
          variant={ButtonVariant.linkPrimary}
          leading={<Icon type={IconType.plusCircle} size={'h-4 w-4'} />}
          onClick={() => navigate(OnboardingRoutes.stockLocationAdd)}
        />
      </div>

      <div className='flex gap-2'>
        <Button
          text={t(TranslationKey.next).singular.label}
          onClick={() => navigate(OnboardingRoutes.stockImport)}
          disabled={!data.summary.stockLocations.size}
        />
        <Button
          text={'Upload a file'}
          variant={ButtonVariant.linkPrimary}
          onClick={() => navigate(OnboardingRoutes.stockLocationImport)}
        />
      </div>
    </div>
  );
}
